import { useState } from "react";
import axios from "axios";
import { enqueueSnackbar } from "notistack";
import { APP_META_TRAVEL_ADS_API_ENDPOINT } from "../../../../constants/api_urls";
import { getUserToken } from "../../../../utils/functions/userToken";

const useSaveCampaignSettings = () => {
  const [isLoading, setIsLoading] = useState(false);
  const token = getUserToken();

  const saveCampaignSettings = async ({
    effectiveCampaignId,
    campaignName,
    biddingStrategy,
    campaignBudget,
    placementDetails,
    targetValue,
    monthlyBudget,
    selectedLanguage,
    selectedCountries,
    clickThroughValue,
    viewThroughValue,
    setDrawerOpen,
    onClose
  }) => {
    if (biddingStrategy === "MAXIMIZE_CONVERSIONS" && campaignBudget !== "" && isNaN(Number(campaignBudget))) {
      enqueueSnackbar("Max CPA must be a valid number", { variant: "error" });
      return;
    }
    try {
      setIsLoading(true);
      setDrawerOpen(true);

      const payload = {
        campaign_id: effectiveCampaignId,
        campaign_settings: {
          campaign_name: campaignName,
          bidding_strategy: {
            bidding_strategy_option: biddingStrategy,
            campaign_target_budget: biddingStrategy === "MAXIMIZE_CONVERSIONS" ? campaignBudget : null,
          },
          placement_platform: placementDetails.placement_platform,
          placement_device: placementDetails.placement_device,
          attr_click_through: Number(clickThroughValue),
          attr_view_through: Number(viewThroughValue),
          budget: {
            default_budget: targetValue,
            ...Object.keys(monthlyBudget).reduce((acc, key, idx) => {
              acc[`budget_month_${idx + 1}`] = monthlyBudget[key] || "";
              return acc;
            }, {}),
          },
          campaign_lang: selectedLanguage.map((lang) => parseInt(lang.id_lang, 10)),
          point_of_sales: selectedCountries,
        },
      };

      await axios.put(
        `${APP_META_TRAVEL_ADS_API_ENDPOINT}/api/meta-ads/edit-campaign/settings/`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      enqueueSnackbar("Campaign settings saved successfully!", { variant: "success" });
    } catch (error) {
      console.error("Error saving campaign settings:", error);
      const data = error?.response?.data;
      const settingsErrors = data?.edit_campaign_settings;

      const messages = [];
      const collectMessages = (val, path = []) => {
        if (Array.isArray(val)) {
          val.forEach((item) => {
            if (item && typeof item === "object" && item.errorMessage) {
              messages.push(` ${item.errorMessage}`);
            } else if (typeof item === "string") {
              messages.push(` ${item}`);
            }
          });
          return;
        }
        if (val && typeof val === "object") {
          Object.entries(val).forEach(([k, v]) => collectMessages(v, [...path, k]));
          return;
        }
        if (typeof val === "string" && val.trim()) {
          messages.push(`${path.join(".")}: ${val}`);
        }
      };

      if (settingsErrors) collectMessages(settingsErrors, ["edit_campaign_settings"]);
      if (Array.isArray(data?.campaign_id) && data.campaign_id.length) {
        collectMessages({ campaign_id: data.campaign_id }, []);
      }

      if (messages.length) {
        messages.forEach((m) => enqueueSnackbar(m, { variant: "error" }));
      } else {
        enqueueSnackbar(data?.errorMessage || data?.message || "Failed to save campaign settings.", { variant: "error" });
      }
    } finally {
      setIsLoading(false);
      setDrawerOpen(false);
    }
  };

  return {
    saveCampaignSettings,
    isLoading
  };
};

export default useSaveCampaignSettings;